module.exports = "/fonts/mpn-picturemark-d-dbcebddd3c88c8fd8837d9a8c928c10d.svg";